module.exports = __webpack_public_path__ + "static/media/teenagers.ecac8bb6.svg";